import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { api } from '../../../../lib/apiClient';
import { neighborsKeys } from './queryKeys';

export const useFetchNeighbors = (annotationId: number | null) => {
  return useQuery({
    queryKey: neighborsKeys.neighbors(annotationId),
    queryFn: async () => {
      if (!annotationId) {
        throw new Error('Annotation id is required to fetch neighbors');
      }
      return api.request(endpoints.annotations.neighbors(annotationId));
    },
    enabled: !!annotationId,
  });
};
